import { Component, OnDestroy, OnInit } from '@angular/core';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { Subscription } from 'rxjs';
import { InstanceInterface } from '../../../models/instance.interface';
import { Apollo, gql } from 'apollo-angular';
import { Study } from '../../../models/study.interface';

@Component({
  selector: 'app-scc-popup',
  templateUrl: './scc-popup.component.html',
  styleUrls: ['./scc-popup.component.scss']
})
export class SccPopupComponent implements OnInit, OnDestroy, IDialogContentComponent<void, { studyId: number }> {
  input?: { studyId: number };

  isLoading = false;
  study?: Study;
  selectedInstances: InstanceInterface[] = [];

  subscriptions: Subscription[] = [];

  constructor(
    private readonly apollo: Apollo,
  ) {}

  ngOnInit(): void {
    this.loadInstances();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  getResult(): InstanceInterface[] {
    return this.selectedInstances;
  }

  isDisabled(): boolean {
    return this.selectedInstances.length === 0;
  }

  isSelected(instance: InstanceInterface): boolean {
    return this.selectedInstances.some(i => i.publicid === instance.publicid);
  }

  get nbInstances(): number {
    let nbInstances = this.study?.series?.filter(s => s.modalityType?.isRadio).map(s => s.instances?.length ?? 0).reduce((acc, val) => acc + val, 0) ?? 0;
    for (const otherStudy of this.study?.patient?.studies ?? []) {
      if (otherStudy.id !== this.study?.id) {
        nbInstances += otherStudy.series?.filter(s => s.modalityType?.isRadio).map(s => s.instances?.length ?? 0).reduce((acc, val) => acc + val, 0) ?? 0;
      }
    }

    return nbInstances;
  }

  toggleSelectAll(): void {
    if (this.selectedInstances.length > 0 && this.selectedInstances.length === this.nbInstances) {
      this.selectedInstances = [];
    } else {
      const allInstances = this.study?.series?.filter(s => s.modalityType?.isRadio).flatMap(s => s.instances ?? []) ?? [];
      for (const otherStudy of this.study?.patient?.studies ?? []) {
        if (otherStudy.id !== this.study?.id) {
          allInstances?.push(...otherStudy.series?.filter(s => s.modalityType?.isRadio).flatMap(s => s.instances ?? []) ?? []);
        }
      }

      this.selectedInstances = allInstances;
    }
  }

  toggleSelectInstance(instance: InstanceInterface): void {
    const index = this.selectedInstances.findIndex(s => s.publicid === instance.publicid);
    if (index === -1) {
      this.selectedInstances.push(instance);
    } else {
      this.selectedInstances.splice(index, 1);
    }
  }

  private loadInstances(): void {
    this.isLoading = true;
    const getStudySeriesInstancesSubscription = this.apollo.query<{
      study: Study;
    }>({
      variables: {
        studyId: this.input?.studyId
      },
      fetchPolicy: 'network-only',
      query: gql`query getStudyInstancesForSccPopup($studyId : Long!) {
        study(studyId: $studyId) {
          id
          date
          name
          patient {
            id
            studies {
              id
              date
              name
              series {
                id
                name
                date
                modalityType {
                  value
                  isRadio
                }
                instances {
                  publicid
                  orthancInstanceUid
                }
              }
            }
          }
          series {
            id
            name
            date
            modalityType {
              value
              isRadio
            }
            instances {
              publicid
              orthancInstanceUid
            }
          }
        }
      }`
    }).subscribe({
      next: data => {
        this.isLoading = false;
        this.study = data.data.study;
      },
      error: error => {
        this.isLoading = false;
        console.log('Erreur lors du chargement des instances', error);
      }
    });

    this.subscriptions.push(getStudySeriesInstancesSubscription);
  }
}
